export type { QuoteCategory, Quote, QuoteStoryTemplate } from "./types";
export { createQuoteStory } from "./types";
export { categories } from "./categories";

import { sabarBaqarah153 } from "./sabar-baqarah-153";
import { ilmuMujadilah11 } from "./ilmu-mujadilah-11";
import { sedekahBaqarah261 } from "./sedekah-baqarah-261";
import { urusanMukmin } from "./urusan-mukmin-muslim";
import { cukupDunia } from "./cukup-dunia-tirmidzi";
import { zakariaAnbiya } from "./zakaria-anbiya-89";
import { sedekahMuslim2588 } from "./sedekah-muslim-2588";
import { ilmuMuslim2699 } from "./ilmu-muslim-2699";
import { yunusAnbiya87 } from "./yunus-anbiya-87";
import { musaTaha25 } from "./musa-taha-25";
import { istiqamahFussilat30 } from "./istiqamah-fussilat-30";
import { tawakkalSalmanFarisi } from "./tawakkal-salman-farisi";
import { puasaSyawalMuslim1164 } from "./puasa-syawal-muslim-1164";
import type { Quote } from "./types";

export const quotes: Quote[] = [sabarBaqarah153, urusanMukmin, cukupDunia, zakariaAnbiya, ilmuMujadilah11, sedekahBaqarah261, sedekahMuslim2588, ilmuMuslim2699, yunusAnbiya87, musaTaha25, istiqamahFussilat30, tawakkalSalmanFarisi, puasaSyawalMuslim1164];
